"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirestoreLanguageManager = void 0;
var tslib_1 = require("tslib");
var firestore_1 = require("firebase/firestore");
var constants_1 = require("../../../constants/constants");
var sdk_1 = require("../../../sdk/sdk");
/**
 * Implementation of the LanguageManagement interface for a FirestoreLanguageManager.
 * @class
 * @implements {LanguageManagement}
 */
var FirestoreLanguageManager = /** @class */ (function () {
    function FirestoreLanguageManager() {
        this.firestoreInstance = (0, firestore_1.getFirestore)();
    }
    FirestoreLanguageManager.prototype.setProfilePreferredLanguage = function (userId, preferredLanguage, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var profileRef, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        profileRef = (0, firestore_1.doc)(this.firestoreInstance, constants_1.COLLECTIONS.ACCOUNTS, userId, constants_1.COLLECTIONS.PROFILES, profileId);
                        return [4 /*yield*/, (0, firestore_1.setDoc)(profileRef, { preferredLanguage: preferredLanguage }, { merge: true })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error setting user preferred language:', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirestoreLanguageManager.prototype.getProfilePreferredLanguage = function (userId, profileId) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var profileDoc, lang, error_2;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 6, , 7]);
                        return [4 /*yield*/, (0, firestore_1.getDoc)((0, firestore_1.doc)(this.firestoreInstance, constants_1.COLLECTIONS.ACCOUNTS, userId, constants_1.COLLECTIONS.PROFILES, profileId))];
                    case 1:
                        profileDoc = _b.sent();
                        if (!profileDoc.exists()) return [3 /*break*/, 2];
                        return [2 /*return*/, (_a = profileDoc.data()) === null || _a === void 0 ? void 0 : _a.preferredLanguage];
                    case 2: return [4 /*yield*/, this.getDefaultLanguage()];
                    case 3:
                        lang = _b.sent();
                        return [4 /*yield*/, this.setProfilePreferredLanguage(userId, lang, profileId)];
                    case 4:
                        _b.sent();
                        return [2 /*return*/, lang];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_2 = _b.sent();
                        console.error('Error getting user preferred language:', error_2);
                        return [2 /*return*/, null];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    FirestoreLanguageManager.prototype.getDefaultLanguage = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var getTheFirstLangFromConfig;
            return tslib_1.__generator(this, function (_b) {
                try {
                    getTheFirstLangFromConfig = (_a = sdk_1.VelvetSDK.Configuration.configuration) === null || _a === void 0 ? void 0 : _a.vocabulary[0].language;
                    // Fallback language (en) if for some reason language from the configuration is not fetched:
                    return [2 /*return*/, getTheFirstLangFromConfig !== null && getTheFirstLangFromConfig !== void 0 ? getTheFirstLangFromConfig : constants_1.DEFAULT_LANGUAGE];
                }
                catch (error) {
                    throw new Error('Error fetching default language configuration: \n' + error);
                }
                return [2 /*return*/];
            });
        });
    };
    FirestoreLanguageManager.prototype.getAvailableLanguages = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                try {
                    return [2 /*return*/, (_a = sdk_1.VelvetSDK.Configuration.configuration) === null || _a === void 0 ? void 0 : _a.vocabulary];
                }
                catch (error) {
                    throw new Error('Error fetching available languages from configuration: \n' + error);
                }
                return [2 /*return*/];
            });
        });
    };
    return FirestoreLanguageManager;
}());
exports.FirestoreLanguageManager = FirestoreLanguageManager;
